import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../_constants/validation-format-constants';

export class AnnouncementRawDto {
    announcementId: number;
    contextList: string[];
    audienceCodes: string[];
    title: string;
    content: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    releaseDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    expirationDate: Date;
}
